import React, { Component } from 'react'
import { enviarComentarioFirma } from '../../recibos/RecibosService';
import BreadCrumComponent from '../BreadCrumComponent';
import img_success from '../../../assets/images/ilustraciones/img-success.svg';
import img_error from '../../../assets/images/ilustraciones/img-error.svg';

export default class AvisoDocumentoFirmado extends Component {

    constructor(props) {
        super(props);

        let data = props.location.state;
        const { accion, tipoDocumento, resultado } = props.match.params;

        this.state = {
            nombreDocumento: data?.nombreDocumento,

            destinatario: data?.destinatario,

            cantidadRecibos: data?.cantidadRecibos,
            descripcionLote: data?.descripcionLote,
            fechaImportacionLote: data?.fechaImportacionLote,

            isComentarioFirma: data?.comentarioFirma,
            comentario: null,



            errorDetalle: data?.errorDetalle,
            backURL: data?.backURL,
            tipoDocumento,
            accion,
            resultado
        };
    }

    handleFinalizar = () => {
        if (this.state.tipoDocumento == 'recibo' && this.state.isComentarioFirma && this.state.comentario != null) {
            enviarComentarioFirma(this.state.comentario).then(res => {
            })
        }
        this.props.history.push('/bandeja/pendientes');
    };

    handleInput = (e) => {
        let name = e.target.name;
        let val = e.target.value;
        this.setState({
            [name]: val,
        })
    };

    getConfig = () => {
        const {
            tipoDocumento,
            nombreDocumento,
            destinatario,
            cantidadRecibos,
            descripcionLote,
            fechaImportacionLote,
            errorDetalle,
            isComentarioFirma

        } = this.state;

        const accion = this.state.accion

        switch (tipoDocumento) {
            case 'tramite':

                switch (accion) {
                    case 'generar':
                        return {
                            subtitle: '¡Su solicitud fue generada exitosamente!',
                            cardInfo: [
                                { label: 'Nombre del documento', content: nombreDocumento },
                                {
                                    label: 'Destinatario(s)',
                                    content: (
                                        <ul className="txt">
                                            {(destinatario || []).map((d, idx) => (
                                                <li key={idx}>{d.nombreCompleto}</li>
                                            ))}
                                        </ul>
                                    )
                                }
                            ],
                            breadcrumb: [
                                { label: 'Generar solicitud ', path: '' },
                                { label: 'Resultados de la operación', path: '' }
                            ]
                        };
                    default:
                        return {
                            subtitle: '¡Su solicitud ha sido firmado y enviada!',
                            cardInfo: [
                                { label: 'Nombre del documento', content: nombreDocumento },
                                {
                                    label: 'Destinatario(s)',
                                    content: (
                                        <ul className="txt">
                                            {(destinatario || []).map((d, idx) => (
                                                <li key={idx}>{d.nombreCompleto}</li>
                                            ))}
                                        </ul>
                                    )
                                }
                            ],
                            breadcrumb: [
                                { label: 'Firma de solicitud ', path: '' },
                                { label: 'Resultados de la operación', path: '' }
                            ]
                        };
                }

            case 'lote':

                switch (accion) {
                    case 'publicar':
                        return {
                            subtitle: '¡Haz publicado el lote exitosamente!',
                            cardInfo:
                                [
                                    { label: 'Documentos publicados', content: cantidadRecibos },
                                    { label: 'Nombre del lote', content: descripcionLote || '--' },
                                    { label: 'Fecha de importación', content: fechaImportacionLote || '--' }
                                ],
                            breadcrumb: [
                                { label: 'Publicar lote', path: '' },
                                { label: 'Resultados de la operación', path: '' }
                            ]
                        };

                    case 'firmar':
                        return {
                            subtitle: '¡Lote firmado exitosamente!',
                            cardInfo: [
                                { label: 'Cantidad de recibos', content: cantidadRecibos },
                                { label: 'Nombre del lote', content: descripcionLote || '--' },
                                { label: 'Fecha de importación', content: fechaImportacionLote || '--' }
                            ],
                            breadcrumb: [
                                { label: 'Firma de lote', path: '' },
                                { label: 'Resultados de la operación', path: '' }
                            ]
                        };
                    default:
                        return {
                            subtitle: '¡Haz aceptado el lote exitosamente!',
                            cardInfo: [
                                { label: 'Cantidad de recibos', content: cantidadRecibos },
                                { label: 'Nombre del lote', content: descripcionLote || '--' },
                                { label: 'Fecha de importación', content: fechaImportacionLote || '--' }
                            ],
                            breadcrumb: [
                                { label: 'Aceptar lote', path: '' },
                                { label: 'Resultados de la operación', path: '' }
                            ]
                        };
                }

            case 'recibo': {
                return {
                    subtitle: accion == 'aceptar' ? '¡Haz aceptado el documento exitosamente!' : '¡Tu Recibo ha sido firmado exitosamente!',
                    cardInfo: [
                        { label: 'Concepto del documento', content: descripcionLote || '--' },
                        { label: 'Fecha de importacion', content: fechaImportacionLote || '--' }
                    ],
                    breadcrumb: [
                        { label: accion !== 'aceptar' ? 'Firma de recibo' : 'Aceptar documento', path: '' },
                        { label: 'Resultados de la operación', path: '' }
                    ]
                };
            }

            case 'error':
            default:
                return {
                    subtitle: 'Ha ocurrido un error durante la firma',
                    cardInfo: [
                        { label: 'Detalles del error', content: errorDetalle }
                    ],
                    breadcrumb: [
                        { label: 'Firma de documento', path: '' },
                        { label: 'Error en la operación', path: '' }
                    ]
                };
        }
    };


    renderResumen = () => {
        const config = this.getConfig();

        return (
            <div className="container-flex container-md">
                <div className="col">
                    <h1 className="section__subtitle-sm">{config.subtitle}</h1>
                    <div className="card">
                        <h3 className="card-title">Aquí tienes un resumen</h3>
                        {config.cardInfo.map((info, idx) => (
                            <div className="card-info" key={idx}>
                                <span className="label">{info.label}</span>
                                <span className="txt">{info.content}</span>
                            </div>
                        ))}
                    </div>
                    {
                        this.state.isComentarioFirma &&
                        <div className="card">
                            <h3 className="card-title">Puedes enviar un comentario si lo deseas</h3>
                            <div className="card-info">
                                <div className="form-group">
                                    <input type="text" id="comentario" name="comentario" className="form-input" placeholder=""
                                        onChange={this.handleInput} value={this.comentario} />
                                    <label htmlFor="comentario" className="form-label"> Comentario opcional </label>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="actions">
                        <button onClick={this.handleFinalizar} className="btn-medium btn-primary">
                            {this.state.resultado === 'error' ? 'Volver a la bandeja' : 'Finalizar'}
                        </button>
                    </div>
                </div>

                <div className="col">
                    <div className="illustration">
                        <img
                            src={this.state.resultado === 'error' ? img_error : img_success}
                            className="img-fluid"
                            alt={this.state.resultado === 'error' ? 'action_error' : 'action_success'}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const config = this.getConfig();

        return (
            <div className="template-base">
                <header className="component-header">
                    <div className="page-container">
                        <BreadCrumComponent
                            backUrl={this.state.backURL}
                            breadcrumbs={config.breadcrumb}
                        />
                    </div>
                </header>

                <div className="wrapperContent">
                    <div className="component-advice">
                        <div className="page-container">
                            {this.renderResumen()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
